import { isAuthorized } from '../../../../../utils/isAuthorized'
import { NavigationMenuItem } from '../types/NavigationMenuItem'

export const hasRequiredScopes = (scopes: NavigationMenuItem['scopes']): boolean => {
  return scopes ? isAuthorized(scopes) : true
}
